var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: { persistent: "" },
      model: {
        value: _vm.showing,
        callback: function ($$v) {
          _vm.showing = $$v
        },
        expression: "showing",
      },
    },
    [
      _c(
        "div",
        { staticClass: "subscriber-editor" },
        [
          _c(
            "v-card",
            [
              _c("v-card-title", { staticClass: "subscriber-editor__header" }, [
                _vm._v(
                  " " +
                    _vm._s(
                      !!_vm.subscriber
                        ? `Edit "${_vm.subscriber.description}"`
                        : "New Subscriber"
                    ) +
                    " "
                ),
              ]),
              _c("v-card-text", [
                _c(
                  "div",
                  { staticClass: "subscriber-editor__data" },
                  [
                    _c("v-select", {
                      ref: "tenantSelectInput",
                      attrs: {
                        items: _vm.tenantOptions,
                        "return-object": "",
                        "item-text": "text",
                        label: "Select Tenant",
                        "persistent-placeholder": "",
                        placeholder: "Select Tenant",
                        dense: "",
                        filled: "",
                        outlined: "",
                        rules: [_vm.rules.required],
                        "menu-props": { bottom: true, offsetY: true },
                      },
                      on: { change: _vm.handleTenantSelection },
                      model: {
                        value: _vm.subscriberData.tenant,
                        callback: function ($$v) {
                          _vm.$set(_vm.subscriberData, "tenant", $$v)
                        },
                        expression: "subscriberData.tenant",
                      },
                    }),
                    _c("v-select", {
                      ref: "channelSelectInput",
                      attrs: {
                        items: _vm.channelTypeOptions,
                        "return-object": "",
                        "item-text": "label",
                        label: "Select Channel Type",
                        "persistent-placeholder": "",
                        placeholder: "Select Channel Type",
                        "no-data-text": "No channels available",
                        "hide-details": "",
                        dense: "",
                        filled: "",
                        outlined: "",
                        rules: [_vm.rules.required],
                        "menu-props": { bottom: true, offsetY: true },
                      },
                      on: { change: _vm.handleChannelTypeSelection },
                      model: {
                        value: _vm.subscriberData.channel,
                        callback: function ($$v) {
                          _vm.$set(_vm.subscriberData, "channel", $$v)
                        },
                        expression: "subscriberData.channel",
                      },
                    }),
                    !!_vm.subscriberData.channel &&
                    !!_vm.subscriberData.channel.specifications &&
                    !!_vm.receiverInfo
                      ? _c(
                          "div",
                          { staticClass: "channel-specifications-cont" },
                          [
                            _c(
                              "div",
                              { staticClass: "channel-specifications__label" },
                              [_vm._v("Specifications")]
                            ),
                            _c(
                              "div",
                              { staticClass: "channel-specifications" },
                              _vm._l(
                                _vm.receiverInfo,
                                function (
                                  specificationItem,
                                  specificationIndex
                                ) {
                                  return _c(
                                    "div",
                                    {
                                      key: `specification-key-${specificationIndex}`,
                                      staticClass: "specification-item",
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "specification-item__label",
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(specificationItem.key) +
                                              " : "
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "specification-item__input",
                                        },
                                        [
                                          _c("v-text-field", {
                                            attrs: {
                                              filled: "",
                                              solo: "",
                                              rules: [
                                                _vm.rules[
                                                  specificationItem.key
                                                ] || "",
                                              ],
                                              dense: "",
                                            },
                                            model: {
                                              value:
                                                _vm.receiverInfo[
                                                  specificationIndex
                                                ].value,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.receiverInfo[
                                                    specificationIndex
                                                  ],
                                                  "value",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "receiverInfo[specificationIndex].value",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ]
                                  )
                                }
                              ),
                              0
                            ),
                          ]
                        )
                      : _vm._e(),
                    _c("v-text-field", {
                      ref: "subscriberDescriptionInput",
                      attrs: {
                        label: "Description",
                        placeholder: "Description",
                        "persistent-placeholder": "",
                        rules: [_vm.rules.required],
                        filled: "",
                        outlined: "",
                        dense: "",
                      },
                      model: {
                        value: _vm.subscriberData.description,
                        callback: function ($$v) {
                          _vm.$set(_vm.subscriberData, "description", $$v)
                        },
                        expression: "subscriberData.description",
                      },
                    }),
                    _c("v-text-field", {
                      attrs: {
                        label: "Daily Quota",
                        placeholder: "Daily Quota",
                        "persistent-placeholder": "",
                        "hide-spin-buttons": "",
                        type: "number",
                        filled: "",
                        outlined: "",
                        dense: "",
                      },
                      model: {
                        value: _vm.subscriberData.dailyQuota,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.subscriberData,
                            "dailyQuota",
                            _vm._n($$v)
                          )
                        },
                        expression: "subscriberData.dailyQuota",
                      },
                    }),
                  ],
                  1
                ),
              ]),
              _c(
                "v-card-actions",
                { staticClass: "subscriber-editor__actions" },
                [
                  _c(
                    "v-btn",
                    { attrs: { plain: "" }, on: { click: _vm.closeEditor } },
                    [_vm._v(" Cancel ")]
                  ),
                  _c(
                    "span",
                    { on: { mouseenter: _vm.touchError } },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            color: "primary",
                            loading: _vm.saving,
                            disabled: _vm.saving || !_vm.canSave,
                          },
                          on: { click: _vm.saveSubscriberHandler },
                        },
                        [_vm._v(" Save ")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }